import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ChatService from "../../services/chat.service";

/* ================= THUNKS ================= */

export const sendMessage = createAsyncThunk(
  "chat/sendMessage",
  async (data, thunkAPI) => {
    try {
      const res = await ChatService.sendMessage(data);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);

export const getMessages = createAsyncThunk(
  "chat/getMessages",
  async (params, thunkAPI) => {
    try {
      const res = await ChatService.getMessage(params);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);

export const getConversations = createAsyncThunk(
  "chat/getConversations",
  async (_, thunkAPI) => {
    try {
      const res = await ChatService.getConversation();
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);
export const getConversationByUser = createAsyncThunk(
  "chat/getConversationByUser",
  async (item, thunkAPI) => {
    try {
      const res = await ChatService.getConversationByUser(item);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);

/* ================= INITIAL STATE ================= */

const initialState = {
  loading: false,
  actionLoading: false,
  error: null,

  conversations: [],   // chat list
  messages: [],        // current chat messages

  updateSuccess: false,
};

/* ================= SLICE ================= */

const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
    clearMessages: (state) => {
      state.messages = [];
    },
  },
  extraReducers: (builder) => {
    builder

      /* ---------- SEND MESSAGE ---------- */
      .addCase(sendMessage.pending, (state) => {
        state.actionLoading = true;
      })
      .addCase(sendMessage.fulfilled, (state, action) => {
        state.actionLoading = false;
        state.updateSuccess = true;

        // push new message instantly (better UX)
        if (action.payload?.data) {
          state.messages.push(action.payload.data);
        }
      })
      .addCase(sendMessage.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.payload;
      })

      /* ---------- GET CONVERSATIONS ---------- */
      .addCase(getConversations.pending, (state) => {
        state.loading = true;
      })
      .addCase(getConversations.fulfilled, (state, action) => {
        state.loading = false;
        state.conversations = action.payload?.data || [];
      })
      .addCase(getConversations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

       /* ---------- GET CONVERSATIONS ---------- */
      .addCase(getConversationByUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(getConversationByUser.fulfilled, (state, action) => {
        state.loading = false;
        state.conversations = action.payload?.data || [];
      })
      .addCase(getConversationByUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- GET MESSAGES ---------- */
      .addCase(getMessages.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMessages.fulfilled, (state, action) => {
        state.loading = false;
        state.messages = action.payload?.data || [];
      })
      .addCase(getMessages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUpdateStatus, clearMessages } = chatSlice.actions;
export default chatSlice.reducer;